<template>
  <div class="result-types__container">
    <mi-chip
      v-for="resultType in resultTypes"
      :key="resultType.value"
      class="result-types__chip"
      :class="selectedResultType === resultType.value? ' result-types__chip-selected' : ''"
      clickable
      @click.stop="selectResultType(resultType.value)"
    >
      {{ resultType.label }}
    </mi-chip>
  </div>
  <div v-if="suggestionItems?.suggestions?.length">
    <!-- Search suggestions items list -->
    <mi-list class="q-mt-xs">
      <mi-list-item
        v-for="(suggestionItem, index) in suggestionItems.suggestions"
        :key="index"
        class="recent-search-item items-center"
        clickable
        dense
        @click.stop="$emit('updateSearchQuery', suggestionItem.id2)"
      >
        <!-- Content -->
        <mi-list-item-section class="block ellipsis">
          <template
            v-for="(chunk, i) in splitHighlight(
              `${ suggestionItem.id2 } - ${ suggestionItem.name }`)"
            :key="i"
          >
            <strong v-if="chunk.bold">{{ chunk.text }}</strong>
            <span v-else>{{ chunk.text }}</span>
          </template>
        </mi-list-item-section>

        <!-- Search Parent btn -->
        <mi-list-item-section side>
          <mi-btn
            v-if="suggestionItem.parentId2 !== null"
            class="recent-search-item__search-parent-btn q-px-sm q-pb-xs"
            :ripple="false"
            dense
            flat
            @click.stop="$emit('updateSearchQuery', suggestionItem.parentId2)"
          >
            Search Parent
          </mi-btn>
        </mi-list-item-section>
      </mi-list-item>
    </mi-list>
  </div>
  <div v-else class="suggestions-empty__container">
    <span class="suggestions-empty__text">No result found</span>
  </div>
</template>

<script>

  import { SEARCH_RESULT_TYPES_SEARCH_BOX } from '@/constants'
  import { ref } from 'vue'
  import MiBtn from '@/packages/@mi-library/MiBtn/MiBtn.vue'
  import MiListItemSection from '@/packages/@mi-library/MiList/MiListItemSection.vue'
  import MiList from '@/packages/@mi-library/MiList/MiList.vue'
  import MiListItem from '@/packages/@mi-library/MiList/MiListItem.vue'
  import MiChip from '@/packages/@mi-library/MiChip/MiChip.vue'

  export default {
    name: 'SearchBoxSuggestions',
    components: { MiChip, MiListItem, MiList, MiListItemSection, MiBtn },
    props: {
      suggestionItems: {
        required: true,
        default: () => [],
        type: Array
      },
      currentSearchString: {
        required: true,
        default: '',
        type: String
      }
    },
    emits: ['updateSearchQuery', 'updateSelectedResultType'],
    setup(props, { emit }) {
      const resultTypes = SEARCH_RESULT_TYPES_SEARCH_BOX
      const selectedResultType = ref(SEARCH_RESULT_TYPES_SEARCH_BOX[0].value)

      const selectResultType = resultType => {
        emit('updateSelectedResultType', resultType)
        selectedResultType.value = resultType
      }

      const splitHighlight = suggestion => {
        const query = props.currentSearchString
        if (!query) {
          return [{ text: suggestion, bold: false }]
        }

        const lowerSuggestion = suggestion.toLowerCase()
        const lowerQuery = query.toLowerCase()

        const index = lowerSuggestion.indexOf(lowerQuery)

        if (index === -1) {
          return [{ text: suggestion, bold: false }]
        }

        return [
          { text: suggestion.slice(0, index), bold: false },
          { text: suggestion.slice(index, index + query.length), bold: true },
          { text: suggestion.slice(index + query.length), bold: false }
        ]
      }

      return {
        resultTypes,
        selectResultType,
        selectedResultType,
        splitHighlight
      }
    }
  }
</script>

<style lang="scss" scoped>
  .result-types {
    &__chip {
      border-radius: 24px;
      padding: 4px 8px;
      height: 24px;
      border-color: #e40045;
      border-style: solid;
      border-width: 1px;
      background: #ffffff;
      color: #e40045;
      font-family: "Man Europe", serif;
      font-weight: 400;
      font-size: 14px;
      line-height: 100%;
      letter-spacing: 0;
      vertical-align: middle;
    }

    &__chip-selected {
      background: #fde2e8;
      border-color: #fde2e8;
    }

    &__container {
      margin: 8px 16px 8px 12px;
    }
  }

  .suggestions-empty {
    &__text {
      font-family: "Man Europe", serif;
      font-weight: 400;
      font-size: 14px;
      line-height: 24px;
      letter-spacing: 0;
      vertical-align: middle;
      color: $mi-anthracite-800;
    }

    &__container {
      padding: 8px 12px;
      margin: 8px 16px;
    }
  }

</style>
